import { Markup } from 'interweave';
import moment from 'moment-timezone';
import type React from 'react';
import type { TenantContactMessage } from 'src/types';

interface SystemMessageProps {
	message: TenantContactMessage;
	jobTimezone: string;
}

const SystemMessage: React.FC<SystemMessageProps> = ({
	message,
	jobTimezone,
}) => {
	const time =
		message.created_date_utc && jobTimezone
			? moment
					.utc(message.created_date_utc, 'YYYY-MM-DD HH:mm:ss')
					.tz(jobTimezone)
					.format('h:mmA z')
			: '';

	return (
		<div className="tenant-texts__row tenant-texts__row--inbound">
			<div
				className="tenant-texts__avatar tenant-texts__avatar--inbound"
				aria-hidden="true"
			>
				<svg
					width="30"
					height="30"
					viewBox="0 0 30 30"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect width="30" height="30" rx="15" fill="#F2F4F7" />
					<path
						d="M19.5898 20.5426H18.5807V21.8447L16.3021 20.5426H10.4101C9.69104 20.5426 9.10806 19.9597 9.10806 19.2406V13.3812C9.10806 12.662 9.69104 12.0791 10.4101 12.0791H19.5898C20.3089 12.0791 20.8919 12.662 20.8919 13.3812V19.2406C20.8919 19.9597 20.3089 20.5426 19.5898 20.5426Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M22.194 18.2637H20.8919V14.3574H22.194C22.5536 14.3574 22.845 14.6489 22.845 15.0085V17.6126C22.845 17.9722 22.5536 18.2637 22.194 18.2637Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9.10806 18.2637H7.80598C7.44641 18.2637 7.15494 17.9722 7.15494 17.6126V15.0085C7.15494 14.6489 7.44641 14.3574 7.80598 14.3574H9.10806V18.2637Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16.3021 15.0088C16.3021 14.4695 16.7393 14.0322 17.2786 14.0322C17.8179 14.0322 18.2552 14.4695 18.2552 15.0088"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M13.6979 15.0088C13.6979 14.4695 13.2607 14.0322 12.7213 14.0322C12.182 14.0322 11.7448 14.4695 11.7448 15.0088"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M13.4294 17.9388C14.2974 18.8069 15.7022 18.8069 16.5703 17.9388"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M17.9297 10.126H12.0703C11.531 10.126 11.0938 10.5632 11.0938 11.1025V12.0791H18.9063V11.1025C18.9063 10.5632 18.469 10.126 17.9297 10.126Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.2552 7.13086C18.2552 7.67018 17.8179 8.10742 17.2786 8.10742C16.7393 8.10742 16.3021 7.67018 16.3021 7.13086C16.3021 6.59154 16.7393 6.1543 17.2786 6.1543C17.8179 6.1543 18.2552 6.59154 18.2552 7.13086Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M11.7448 7.13086C11.7448 7.67018 12.182 8.10742 12.7213 8.10742C13.2607 8.10742 13.6979 7.67018 13.6979 7.13086C13.6979 6.59154 13.2607 6.1543 12.7213 6.1543C12.182 6.1543 11.7448 6.59154 11.7448 7.13086Z"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M17.2786 8.10775V10.126"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M12.7213 8.10775V10.126"
						stroke="#667085"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
			<div className="tenant-texts__content tenant-texts__content--inbound">
				<div className="tenant-texts__bubble tenant-texts__system-bubble">
					<p className="tenant-texts__text">
						<Markup content={message?.text} />
					</p>
				</div>
				{time ? <span className="tenant-texts__time">{time}</span> : null}
			</div>
		</div>
	);
};

export default SystemMessage;
